<template>
    <b-container>
      <b-row v-if="form.type==='live' && $auth.getMyUser().client_infos[0].directstream" class="justify-content-center marginaltop">
        <b-col cols="auto">
          <b-btn variant="msstreamblue" @click="$router.push('/directstream')">
            <font-awesome-icon icon="sign-out-alt"></font-awesome-icon> Direct live stream (Experimental)
          </b-btn>
        </b-col>
      </b-row>
      <b-card v-if="panel === 'creation'" class="marginal" no-body border-variant="msstream">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">Video creation - {{form.type.toUpperCase()}}</b-card-header>
        <b-card-body>
            <VideoForm :videoComponent="form.type"/>
        </b-card-body>
      </b-card>
    </b-container>
</template>

<script>
import VideoForm from '@/components/VideoForm.vue';
export default {
  name: 'videoupload',
  components: {
    VideoForm

  },
  data() {
    return {
      form: {
        type: 'vod'
      },
      isUploading: false,
      panel: 'creation'
    }
  },
  mounted() {
    if (this.$route.params["videoType"]) {
        this.form.type = this.$route.params["videoType"];
    }
  },
  beforeRouteLeave: function(to, from, next) {
    if (this.isUploading) {
      const answer = window.confirm('Do you really want to leave? The videos not uploaded will be empty.')
      if(answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },

}
</script>
